module.exports = "data:image/gif;base64,R0lGODlhBwADAJEAAPT56////6XOVQAAACH5BAAAAAAALAAAAAAHAAMAAAIHlBFpgnoZCgA7"